module.exports = __webpack_public_path__ + "static/img/nguyenduchiet.1162122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nguyenduchiet.png
// module id = jtr5
// module chunks = 1